import { BRAND } from '@/components/brand-name/brand-name';
import env from '@/env';

export const DEFAULT_DESCRIPTION =
  'PredictIt is a real-money political prediction market, where you can buy and sell shares in the outcome of elections and other political events.';
const TWITTER_SITE = env.TWITTER_HANDLE ? `@${env.TWITTER_HANDLE}` : '';

const seoMetaMixin = {
  methods: {
    buildSeoMeta(options = {}) {
      const title = options.title || BRAND;
      const description = options.description || DEFAULT_DESCRIPTION;
      const image = options.image || '';
      const type = options.type || 'website';
      const url =
        options.url ||
        (typeof window !== 'undefined'
          ? `${window.location.origin}${window.location.pathname}`
          : '');
      const siteName = options.siteName || BRAND;
      const article = options.article || null;
      const extraMeta = options.extraMeta || [];

      const meta = [
        { name: 'description', content: description },
        { itemprop: 'name', content: title },
        { itemprop: 'description', content: description },
        image && { itemprop: 'image', content: image },
        { property: 'og:title', content: title },
        { property: 'og:type', content: type },
        { property: 'og:description', content: description },
        { property: 'og:site_name', content: siteName },
        { property: 'og:url', content: url },
        image && { property: 'og:image', content: image },
        { name: 'twitter:card', content: image ? 'summary_large_image' : 'summary' },
        TWITTER_SITE && { name: 'twitter:site', content: TWITTER_SITE },
        TWITTER_SITE && { name: 'twitter:creator', content: TWITTER_SITE },
        { name: 'twitter:title', content: title },
        { name: 'twitter:description', content: description },
        image && { name: 'twitter:image', content: image },
      ];

      if (type === 'article' && article) {
        if (article.publishedTime) {
          meta.push({ property: 'article:published_time', content: article.publishedTime });
        }
        if (article.modifiedTime) {
          meta.push({ property: 'article:modified_time', content: article.modifiedTime });
        }
      }

      return {
        title,
        link: [{ rel: 'canonical', href: url }],
        meta: meta.concat(extraMeta).filter(Boolean),
      };
    },
  },
};

export default seoMetaMixin;
